// Roles with global, all-access scope by role — they edit every restaurant and
// grocery regardless of assignment (backend `_ALL_ACCESS_ROLES`), so the
// user-management forms must NOT ask them to pick specific merchants.
export const GLOBAL_ACCESS_ROLES = ['Resort Super Admin', 'Supervisor', 'Editor'];

export const isGlobalRole = (role: string): boolean => GLOBAL_ACCESS_ROLES.includes(role);

// Roles that need no restaurant/grocery assignment at all (global roles + Support).
export const noMerchantSelection = (role: string): boolean =>
  role === 'Support' || isGlobalRole(role);
